export default __webpack_public_path__ + "static/media/arrow-up.313d2350.png";